// extracted by mini-css-extract-plugin
export default {"hidden":"mystyle_hidden__4JmEd","revealer":"mystyle_revealer__DcIpW"};